var React = require('react');

function Refrigerator (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M336,.5H48a48,48,0,0,0-48,48v112H288v-88a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8v88h64V48.5A48,48,0,0,0,336,.5Zm-16,376a8,8,0,0,1-8,8H296a8,8,0,0,1-8-8v-184H0v272a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48v-272H320Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0,192.5H288v-32H0Zm320-32v32h64v-32Z","className":"fa-primary","key":2})]);
}

Refrigerator.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Refrigerator;

Refrigerator.default = Refrigerator;
